const installationInstructions = {
  powerDevice: {
    currentStep: 'powerDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    prevStepName: 'https://return-to-app',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/camera/camera_power.png'),
    resourceType: 'image',
    primaryTx: 'categories.camera.powerDevice.title',
    secondaryTx: 'categories.camera.powerDevice.subtitle',
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'powerDevice',
      titleTx: 'categories.camera.stepsToReset',
    },
  },
  confirmPairingMode: {
    currentStep: 'confirmPairingMode',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    resource: require('@/assets/categories/camera/camera_pairing_mode.png'),
    resourceType: 'image',
    primaryTx: 'categories.camera.confirmPairingMode.title',
    secondaryTx: 'categories.camera.confirmPairingMode.subtitle',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    primaryActionKey: 'chooseProvider', // Choose Pepper or Tuya FW
    continueButtonTx: 'common.continue',
    alternateNextStep: {
      nextStep: 'resetDevice',
      nextStepName: 'categoryInstructions',
      lastStep: 'confirmPairingMode',
      titleTx: 'categories.camera.stepsToReset',
    },
  },
  resetDevice: {
    headerIcon: 'closeBlack',
    prevStep: 'powerDevice',
    prevStepName: 'categoryInstructions',
    currentStep: 'resetDevice',
    nextStep: 'confirmPairingMode',
    nextStepName: 'categoryInstructions',
    headerOverridingClass: 'background-gray',
    headerTitleTx: 'categories.camera.stepsToReset',
    carousel: {
      showPageIndicator: true,
      slides: [
        {
          resourceType: 'image',
          resource: require('@/assets/categories/camera/reset_step1.png'),
          primaryTx: 'categories.camera.resetDevice.step1.title',
          secondaryTx: 'categories.camera.resetDevice.step1.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/camera/reset_step2.png'),
          primaryTx: 'categories.camera.resetDevice.step2.title',
          secondaryTx: 'categories.camera.resetDevice.step2.subtitle',
        },
        {
          resourceType: 'image',
          resource: require('@/assets/categories/camera/reset_camera_step_3.gif'),
          primaryTx: 'categories.camera.resetDevice.step3.title',
          secondaryTx: 'categories.camera.resetDevice.step3.subtitle',
        }
      ]
    }
  },
};

export default installationInstructions;
